import React from 'react';
import { Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import Linearicons from './components/IconList';

const Icons = () => (
  <Container>
    <Row>
      <Linearicons />
    </Row>
  </Container>
);

export default withTranslation('common')(Icons);
